/**
 * @fileoverview Component for displaying an empty list of sites.
 * This component includes a message and an icon.
 */

import SitesIcon from '../../assets/menu/sites.svg'

/**
 * @function SiteEmptyList
 * @description Component for displaying an empty list of sites.
 * @returns {JSX.Element} - A React component that renders the empty list of sites.
 */
export function SiteEmptyList() {
    return (
        <div className="flex flex-col grow justify-center mt-32 px-8 py-8">
            <div className="flex self-center flex-col items-center">
                <div className="flex justify-center items-center w-16 h-16 rounded-full bg-indigo-50 mb-4">
                    <SitesIcon className="w-6 h-6 stroke-indigo-500 stroke-2" />
                </div>
                <h2 className="mb-3 text-gray-900 text-xl font-semibold">No sites to display</h2>
                <p className="text-base text-gray-600 max-w-[486px] text-center">
                    No matching sites or insufficient permissions to view.
                </p>
            </div>
        </div>
    )
}
